module.exports = __webpack_public_path__ + "static/coldenrod-5f5679aeaaa5027d5b81791dfd363372.png";